import { Component, EventEmitter, HostBinding, Input, Output, OnInit } from '@angular/core';

export type ButtonState = 'initial' | 'loading' | 'success';

@Component({
  selector: 'app-stat',
  templateUrl: './app-stat.component.html',
  styleUrls: ['./app-stat.component.scss'],
})
export class AppStatComponent implements OnInit {

  @Input() statItem?: string;
  @Input() statVal?: any;
  @Input() statUnit?: any;
  @Input() statInfo?: any;
  @Input() statName?: any;

  @Input() iconSrc?: string;


  @Output() mainFunction? = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {
    
  }

  async onButtonClick() {
    this.mainFunction.emit(); 
  }
}